<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode"></ParseForm>
      </template>    
      <template>
        <ParseList ref='area' :formId="formItems.area.formId" :formParams="formItems.area.formObj" :opCode="opCode" :Title="formItems.area.title"
          :maxLength="formItems.area.maxLength" :minLength="formItems.area.minLength" >
        </ParseList>
      </template>
      <!-- <template>
        <ParseList ref='edrx' :formId="formItems.edrx.formId" :formParams="formItems.edrx.formObj" :opCode="opCode" :Title="formItems.edrx.title"
          :maxLength="formItems.edrx.maxLength" :minLength="formItems.edrx.minLength" >
        </ParseList>
      </template>  -->
    </div>
  </div>
</template>
<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import ParseList from '../../../util/parseFormNew/ParseList';
import CustomDialog from '../../../../common/CustomDialog';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: "ModProfileForm",
  components: {
    ParseForm,
    CustomDialog,
    ParseList
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
       if (this.$refs.area) {
        if (!this.$refs.area.validateResult()) {

          return;
        }
        const area = this.$refs.area.getDatas();
        map.set('areaObj', area.list);
      }
      // if (this.$refs.edrx) {
      //   if (!this.$refs.edrx.validateResult()) {
      //     return;
      //   }
      //   const edrx = this.$refs.edrx.getDatas();
      //   map.set('edrxParametersObj', edrx.list);
      // }
      console.log(map);
      return map;
    },
    getJson(ne, checkedDatas, callback) {  
      this.ne = ne;
      console.log("===",checkedDatas[0])
      const checkedRecord = {
        ...checkedDatas[0],
         areaObj: {
          count:  checkedDatas[0].areaList.length,
          list: checkedDatas[0].areaList,
        },
        //  edrxParametersObj: {
        //   count:  checkedDatas[0].edrxParametersList.length,
        //   list: checkedDatas[0].edrxParametersList,
        // },
      };
      if(checkedRecord.ratRestrictions!=0){
      checkedRecord.ratRestrictions=parseInt(10,2)//暂时写死，因为checkbox是从1开始
      }
      // checkedDatas[0].edrxParametersList.map((obj) => {
      //   if(obj.ratType=="ETURA"){
      //      obj.ratType=1;
      //   }
      //   else if(obj.ratType=="NBIOT"){
      //      obj.ratType=2;
      //   }
      //   else if(obj.ratType=="LTE-M"){
      //      obj.ratType=3;
      //   }
      // });

      console.log('checkedRecord',checkedRecord);
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.amdataJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;

        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, checkedRecord);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);      
        this.formItems.area.formObj = resultMap.get(this.formItems.area.modelName);
        // this.formItems.edrx.formObj = resultMap.get(this.formItems.edrx.modelName);
        callback(response);
      });      
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();      
      if (formData) {
        const areaList = formData.get("areaObj");
        const areaListNew=[];
        for(var i=0;i<areaList.length;i++){
          if((areaList[i].areaType==0&&areaList[i].tac!="")||(areaList[i].areaType==0&&areaList[i].areaCode!="")){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("AmData.areaTypeNotNull")});
            return false
          }
          else if(!(areaList[i].areaType==0&&areaList[i].tac==""&&areaList[i].areaCode=="")){//不都是空的情况下就保留数据
            console.log("areaList[i].tac",areaList[i].tac)
            if(""!=areaList[i].tac){
              let tacStr=areaList[i].tac;
              const tacSplit=tacStr.split(",")
              for(var k=0;k<tacSplit.length;k++){
                if(""==tacSplit[k]){
                  EventBus.$emit('toast', {type: 'warning', content: "格式不合法"});
                  return false
                }
                if(parseInt(tacSplit[k])<1||parseInt(tacSplit[k])>16777215){
                  EventBus.$emit('toast', {type: 'warning', content: "跟踪区域码有数值不在1~16777215内"});
                  return false
                }
              }
            }
            areaListNew.push(areaList[i]);
          }
        }

        // const edrxParametersList = formData.get("edrxParametersObj");
        // console.log("edrxParametersList",edrxParametersList)
        // const edrxParametersListNew=[];
        
        // for(var i=0;i<edrxParametersList.length;i++){
        //   if((edrxParametersList[i].ratType==0&&edrxParametersList[i].edrxValue!="")||(edrxParametersList[i].ratType!=0&&edrxParametersList[i].edrxValue=="")){
        //     EventBus.$emit('toast', {type: 'warning', content: this.$t("AmData.notAllowOne")});
        //     return false
        //   }
        //   else if(edrxParametersList[i].ratType!=0&&edrxParametersList[i].edrxValue!=""){//不都是空的情况下就保留数据  ratType不填写就是0
        //     if(edrxParametersList[i].ratType==1){
        //        edrxParametersList[i].ratType="ETURA";
        //     }
        //     else if(edrxParametersList[i].ratType==2){
        //        edrxParametersList[i].ratType="NBIOT";
        //     }
        //     else if(edrxParametersList[i].ratType==3){
        //        edrxParametersList[i].ratType="LTE-M";
        //     }
        //     edrxParametersListNew.push(edrxParametersList[i]);
        //   }
        // }
        
        if(areaListNew.length==2){
          if(areaListNew[0].areaType!=3&&areaListNew[1].areaType!=3){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("AmData.conflict")});
            return false
          }
          else if(areaListNew[0].areaType==3&&areaListNew[1].areaType==3){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("AmData.conflict")});//可行的下发数据组合只有这两种：1.允许，禁止（顺序可互换）；2.非允许，禁止（顺序可互换）
            return false
          }
        }   
        const params = { 
        vo: {
            "neid": ne.neid,
            "profileId": parseInt(formData.get("profileId")),
            "profileName": formData.get("profileName"),
            "ueAmbrUp": parseInt(formData.get("ueAmbrUp")),
            "ueAmbrDown": parseInt(formData.get("ueAmbrDown")),
            "RFSPindex": formData.get("RFSPindex")==0?0:parseInt(formData.get("RFSPindex")),
            "ratRestrictions": parseInt(formData.get("ratRestrictions"))==0?0:1,//暂时写这样，后续更改
            "areaList": areaListNew,
            // "edrxParametersList": edrxParametersListNew,
            "micoAllowed": parseInt(formData.get("micoAllowed")),
          },  
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        console.log("params",params);
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
  },
  computed: {
  },
  data() {
    return {      
      ne: null,
      selectedKeys: [],
      funcMap: null,
      formItems: {
        basic: {
          formId: "AmDataModProfileInfo",
          modelName: "basic",
          formObj: null,
        },
        area: {
          title: this.$t("AmData.areaForbid"),
          formId: "ProfileModMccMncInfo",
          modelName: "area",
          formObj: null,
          maxLength: 2,
          minLength: 0,
        },
        // edrx: {
        //   title: this.$t("AmData.edrx"),
        //   formId: "ProfileModedrx",
        //   modelName: "edrx",
        //   formObj: null,
        //   maxLength: 3,
        //   minLength: 0,
        // },
      },  
      opCode: "mod",
      msgId: "28681",
    };
  },  
  beforeDestroy() {
  }
};
</script>

